// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e841fc14","455":"24dcc8d7","977":"008fd00b"}[chunkId] + ".chunk.js";
};